'use client';

// Temporary component for backward compatibility.
// This should be removed once it is safe to use the /api/player request from the SS.
// Do not add extra logic here; it is only for legacy footer rendering.

import Link from 'next/link';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { CustomFooterGroups, getCopyrightConfig } from './helpers';
import { matchGroupMember } from '@/helpers/user';
import { useCommonStore } from '@/store';

import { ScFooterCopyright } from './styled';

interface ISafeFooterCopyright {
  children: React.ReactNode;
  i18nKeyServer: string;
  userIP: string | null;
  isEstonia: boolean;
  currentFullYear: number;
  copyrightDomain: string;
}

export const SafeFooterCopyright = ({
  children,
  userIP,
  isEstonia,
  currentFullYear,
  copyrightDomain,
  i18nKeyServer,
}: ISafeFooterCopyright) => {
  const { t } = useTranslation();
  const { pendingUser, footerGroups } = useCommonStore(
    useShallow((s) => ({
      footerGroups: matchGroupMember([
        CustomFooterGroups.STRUKIN,
        CustomFooterGroups.FRIOLION,
      ])(s.user),
      pendingUser: s.pendingUser,
    }))
  );

  const [isStrukin, isFriolion] = footerGroups;
  const { i18nKey, links } = getCopyrightConfig(
    userIP,
    isEstonia,
    isStrukin,
    isFriolion
  );

  // If user data is still loading or matches the server key, render children as-is
  if (pendingUser || i18nKey === i18nKeyServer) {
    return children;
  }

  // If there is a mismatch, render the updated footer
  console.warn('Server footer data mismatch!');
  return (
    <ScFooterCopyright>
      <Trans
        ns="common"
        i18nKey={i18nKey}
        values={{ year: currentFullYear, domain: copyrightDomain }}
        t={t}
        components={{
          p: <p />,
          1: <Link href={links.terms} />,
          2: <Link href={links.responsibleGaming} />,
        }}
      />
    </ScFooterCopyright>
  );
};
